


























































































import Vue from 'vue'
import { ProjectDetailHeader } from '@/model/project/ProjectDetailHeader'
import { EDIT_PROJECT } from '@/store/action-types'
import moment from 'moment'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import NumberFieldOptions from '@/components/project/NumberFieldOptions.vue'

interface ComponentData {
  loading: boolean
  loadingEdit: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  formIsValid: boolean
  validationRulesSum1: Function[]
  validationRulesSum2: Function[]
  validationRulesSum3: Function[]
  validationRulesProzent1: Function[]
  validationRulesBetrag1: Function[]
  validationRulesProzent2: Function[]
  validationRulesBetrag2: Function[]
  validationRulesEinschreiben: Function[]
  validationRulesExpress: Function[]
  validationRulesNachnahme: Function[]
  validationRules1: Function[]
  validationRules2: Function[]
  validationRules3: Function[]

  Kontoplan: any[]
  Steuersaetze: any[]

  RabattSum: number | null
  RabattProzent: boolean
  RabattBetrag: boolean
  RabattSteuer: number | null
  RabattKonto: number | null
  ZuschlagSum: number | null
  ZuschlagProzent: boolean
  ZuschlagBetrag: boolean
  ZuschlagSteuer: number | null
  ZuschlagKonto: number | null
  SpesenSum: number | null
  SpesenEinschreiben: boolean
  SpesenExpress: boolean
  SpesenNachnahme: boolean
  SpesenSteuer: number | null
  SpesenKonto: number | null
  QRAltVerfahren1: string
  QRAltVerfahren2: string
  QRZusatz: string
}

export default Vue.extend({
  name: 'ProjectOptions',

  components: {
    NumberFieldOptions
  },

  props: {
    metaData: Object as () => any | null,
    projectId: Number,
    projectDetailHeader: Object as () => ProjectDetailHeader,
    isEditProject: Boolean
  },

  data (): ComponentData {
    return {
      loading: false,
      loadingEdit: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      formIsValid: false,
      validationRulesSum1: [
        (v: any) => {
          //@ts-ignore
          if (this.RabattProzent || this.RabattBetrag || this.RabattSteuer || this.RabattKonto) {
            return !!v || this.$t('project.required').toString()
          } else {
            return true
          }
        }
      ],
      validationRulesSum2: [
        (v: any) => {
          //@ts-ignore
          if (this.ZuschlagProzent || this.ZuschlagBetrag || this.ZuschlagSteuer || this.ZuschlagKonto) {
            return !!v || this.$t('project.required').toString()
          } else {
            return true
          }
        }
      ],
      validationRulesSum3: [
        (v: any) => {
          //@ts-ignore
          if (this.SpesenEinschreiben || this.SpesenExpress || this.SpesenNachnahme || this.SpesenSteuer || this.SpesenKonto) {
            return !!v || this.$t('project.required').toString()
          } else {
            return true
          }
        }
      ],
      validationRulesProzent1: [
        (v: any) => {
          //@ts-ignore
          if (this.RabattSum && !this.RabattBetrag) {
            return !!v || this.$t('project.required').toString()
          } else {
            return true
          }
        }
      ],
      validationRulesBetrag1: [
        (v: any) => {
          //@ts-ignore
          if (this.RabattSum && !this.RabattProzent) {
            return !!v || this.$t('project.required').toString()
          } else {
            return true
          }
        }
      ],
      validationRulesProzent2: [
        (v: any) => {
          //@ts-ignore
          if (this.ZuschlagSum && !this.ZuschlagBetrag) {
            return !!v || this.$t('project.required').toString()
          } else {
            return true
          }
        }
      ],
      validationRulesBetrag2: [
        (v: any) => {
          //@ts-ignore
          if (this.ZuschlagSum && !this.ZuschlagProzent) {
            return !!v || this.$t('project.required').toString()
          } else {
            return true
          }
        }
      ],
      validationRulesEinschreiben: [
        (v: any) => {
          //@ts-ignore
          if (this.SpesenSum && !this.SpesenExpress && !this.SpesenNachnahme) {
            return !!v || this.$t('project.required').toString()
          } else {
            return true
          }
        }
      ],
      validationRulesExpress: [
        (v: any) => {
          //@ts-ignore
          if (this.SpesenSum && !this.SpesenEinschreiben && !this.SpesenNachnahme) {
            return !!v || this.$t('project.required').toString()
          } else {
            return true
          }
        }
      ],
      validationRulesNachnahme: [
        (v: any) => {
          //@ts-ignore
          if (this.SpesenSum && !this.SpesenEinschreiben && !this.SpesenExpress) {
            return !!v || this.$t('project.required').toString()
          } else {
            return true
          }
        }
      ],
      validationRules1: [
        (v: any) => {
          //@ts-ignore
          if (this.RabattSum) {
            return !!v || this.$t('project.required').toString()
          } else {
            return true
          }
        }
      ],
      validationRules2: [
        (v: any) => {
          //@ts-ignore
          if (this.ZuschlagSum) {
            return !!v || this.$t('project.required').toString()
          } else {
            return true
          }
        }
      ],
      validationRules3: [
        (v: any) => {
          //@ts-ignore
          if (this.SpesenSum) {
            return !!v || this.$t('project.required').toString()
          } else {
            return true
          }
        }
      ],

      Kontoplan: [],
      Steuersaetze: [],

      RabattSum: null,
      RabattProzent: false,
      RabattBetrag: false,
      RabattSteuer: null,
      RabattKonto: null,
      ZuschlagSum: null,
      ZuschlagProzent: false,
      ZuschlagBetrag: false,
      ZuschlagSteuer: null,
      ZuschlagKonto: null,
      SpesenSum: null,
      SpesenEinschreiben: false,
      SpesenExpress: false,
      SpesenNachnahme: false,
      SpesenSteuer: null,
      SpesenKonto: null,
      QRAltVerfahren1: '',
      QRAltVerfahren2: '',
      QRZusatz: ''
    }
  },

  watch: {
    projectDetailHeader(newVal: ProjectDetailHeader | undefined): void {
      if(newVal) {
        this.setData(newVal)
      }
    },

    isEditProject (): void {
      if(this.isEditProject) {
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    },

    RabattProzent (newVal: boolean): void {
      if(newVal) {
        this.RabattBetrag = false
      }
    },
    RabattBetrag (newVal: boolean): void {
      if(newVal) {
        this.RabattProzent = false
      }
    },
    ZuschlagProzent (newVal: boolean): void {
      if(newVal) {
        this.ZuschlagBetrag = false
      }
    },
    ZuschlagBetrag (newVal: boolean): void {
      if(newVal) {
        this.ZuschlagProzent = false
      }
    },
    SpesenEinschreiben (newVal: boolean): void {
      if(newVal) {
        this.SpesenExpress = false
        this.SpesenNachnahme = false
      }
    },
    SpesenExpress (newVal: boolean): void {
      if(newVal) {
        this.SpesenEinschreiben = false
        this.SpesenNachnahme = false
      }
    },
    SpesenNachnahme (newVal: boolean): void {
      if(newVal) {
        this.SpesenEinschreiben = false
        this.SpesenExpress = false
      }
    },
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    }
  },

  methods: {
    getLabel (item: any): string {
      return `${item.Nummer} - ${item.Bezeichnung}`
    },

    setData (data: ProjectDetailHeader): void {
      const form: any = this.$refs['form']
      if (form) {
        form.resetValidation()
      }

      if(this.metaData) {
        this.Kontoplan = this.metaData.Data.ds05
        this.Steuersaetze = this.metaData.Data.ds09
      }

      this.RabattSum = data.Rabatt ? parseFloat(data.Rabatt.replace(',', '.')) : null
      this.RabattProzent = !!(data.RabattProzent && data.RabattProzent === "True")
      this.RabattBetrag = !!(data.RabattBetrag && data.RabattBetrag === "True")
      this.RabattSteuer = data.Rabattsteuer ? parseInt(data.Rabattsteuer) : null
      this.RabattKonto = data.RabattKonto ? parseInt(data.RabattKonto) : null
      this.ZuschlagSum = data.Zuschlag ? parseFloat(data.Zuschlag.replace(',', '.')) : null
      this.ZuschlagProzent = !!(data.ZuschlagProzent && data.ZuschlagProzent === "True")
      this.ZuschlagBetrag = !!(data.ZuschlagBetrag && data.ZuschlagBetrag === "True")
      this.ZuschlagSteuer = data.Zuschlagsteuer ? parseInt(data.Zuschlagsteuer) : null
      this.ZuschlagKonto = data.ZuschlagKonto ? parseInt(data.ZuschlagKonto) : null
      this.SpesenSum = data.Versandspesen ? parseFloat(data.Versandspesen.replace(',', '.')) : null
      this.SpesenEinschreiben = !!(data.Einschreiben && data.Einschreiben === "True")
      this.SpesenExpress = !!(data.Express && data.Express === "True")
      this.SpesenNachnahme = !!(data.Nachnahme && data.Nachnahme === "True")
      this.SpesenSteuer = data.Versandsteuer ? parseInt(data.Versandsteuer) : null
      this.SpesenKonto = data.VersandKonto ? parseInt(data.VersandKonto) : null
      this.QRAltVerfahren1 = data.QRAltVerfahren1 ? data.QRAltVerfahren1 : ''
      this.QRAltVerfahren2 = data.QRAltVerfahren2 ? data.QRAltVerfahren2 : ''
      this.QRZusatz = data.QRZusatz ? data.QRZusatz : ''
    },

    onCancelClick (): void {
      this.$emit('onCancelProjectHeaderClick')
      this.setData(this.projectDetailHeader)
    },

    onSaveProjectHeaderClick (): void {
      if(this.isEditProject) {
        const form: any = this.$refs['form']
        if (form.validate()) {
          this.updateProject()
        }
      }
    },

    async updateProject (): Promise<void> {
      const payload: any = {
        ID: this.projectId,
        Titel: this.projectDetailHeader.Titel ? this.projectDetailHeader.Titel : '',
        Profitcenter: this.projectDetailHeader.ProfitCenter ? parseInt(this.projectDetailHeader.ProfitCenter) : null,
        Sachbearbeiter: this.projectDetailHeader.Sachbearbeiter ? parseInt(this.projectDetailHeader.Sachbearbeiter) : null,
        UnsereReferenz: this.projectDetailHeader.UnsereReferenz ? parseInt(this.projectDetailHeader.UnsereReferenz) : null,
        IhreReferenz: this.projectDetailHeader.IhreReferenz ? this.projectDetailHeader.IhreReferenz : '',
        Lieferkondition: this.projectDetailHeader.Lieferkondition ? parseInt(this.projectDetailHeader.Lieferkondition) : null,
        Zahlungskondition: this.projectDetailHeader.Zahlungskondition ? parseInt(this.projectDetailHeader.Zahlungskondition) : null,
        Versandart: this.projectDetailHeader.Versandart ? parseInt(this.projectDetailHeader.Versandart) : null,
        ReferenzTermin: this.projectDetailHeader.ReferenzTermin ? moment(this.projectDetailHeader.ReferenzTermin).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
        ProjektDatum: this.projectDetailHeader.ProjektDatum ? moment(this.projectDetailHeader.ProjektDatum).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
        EingangVia: this.projectDetailHeader.EingangViaWert ? parseInt(this.projectDetailHeader.EingangViaWert) : null,
        Kommission: this.projectDetailHeader.KommissionID ? parseInt(this.projectDetailHeader.KommissionID) : null,
        Adresse: this.projectDetailHeader.Adresse,
        QRZusatz: this.QRZusatz,
        QRAltVerfahren1: this.QRAltVerfahren1,
        QRAltVerfahren2: this.QRAltVerfahren2,
        Rabatt: this.RabattSum,
        RabattProzent: this.RabattProzent ? 1 : 0,
        RabattBetrag: this.RabattBetrag ? 1 : 0,
        RabattKonto: this.RabattKonto,
        RabattSteuer: this.RabattSteuer,
        Zuschlag: this.ZuschlagSum,
        ZuschlagProzent: this.ZuschlagProzent ? 1 : 0,
        ZuschlagBetrag: this.ZuschlagBetrag ? 1 : 0,
        ZuschlagKonto: this.ZuschlagKonto,
        ZuschlagSteuer: this.ZuschlagSteuer,
        Express: this.SpesenExpress ? 1 : 0,
        Einschreiben: this.SpesenEinschreiben ? 1 : 0,
        Nachnahme: this.SpesenNachnahme ? 1 : 0,
        Versandspesen: this.SpesenSum,
        VersandKonto: this.SpesenKonto,
        VersandSteuer: this.SpesenSteuer,
      }

      try {
        this.loadingEdit = true
        this.$emit('onEditLoading', true)
        const response: any = await this.$store.dispatch(EDIT_PROJECT, payload)
        this.loadingEdit = false
        this.$emit('onEditLoading', false)
        if(!response.IsError) {
          this.$emit('onEdited')
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loadingEdit = false
        this.$emit('onEditLoading', false)
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  mounted () {
    if(this.projectDetailHeader) {
      this.setData(this.projectDetailHeader)
    }
  }
})
